// extracted by mini-css-extract-plugin
export default {"email_Box":"Form_email_Box__1PMAL","radio_box":"Form_radio_box__zP0vw"};